module.exports = __webpack_public_path__ + "img/bg-product-4.d2efb549.png";